const LS_SERVICE = {
    get: function (key) {
        var value = window.localStorage.getItem(key);

        var decoded = JSON.parse(value);

        // if (decoded) {
        return decoded;
        // }

        // return defaultValue;
    },

    set: function (key, value) {
        if (value !== "") window.localStorage.setItem(key, JSON.stringify(value));
        else window.localStorage.removeItem(key);
    },

    edit: function (key, value) {
        var decoded = JSON.parse(value);

        if (decoded) {
            this.set(key, value);
        }
    },

    delete: function (key) {
        this.set(key, "");
    },

    has: function (key) {
        // Use getItem (not hasOwnProperty) so the key is resolved through the
        // localStorage override (per-tab namespacing / shared-key whitelist).
        return window.localStorage.getItem(key) !== null;
    },

    clear: function () {
        window.localStorage.clear();
    },
};

export default LS_SERVICE;